import MAMoonATSPage from './MAMoonATSPage'
// Uncomment the below to migrate to stateful component
// import MAMoonATSPageContainer from './MAMoonATSPageContainer'

export { MAMoonATSPage }
export default MAMoonATSPage
// Uncomment the below to migrate to stateful component
// export { MAMoonATSPageContainer }
// export default { MAMoonATSPageContainer }
